<opac-dialog size="large" [open]="isOpen()" (closed)="closeDialog()">
  <div class="header" slot="header">
    <opac-button
      class="navigate-back"
      *ngIf="step() === 'settings'"
      (click)="changeStep('overview', $event)"
      [ariaLabel]="'common.back' | translate"
      [opacTooltip]="'common.back' | translate">
      <opac-icon slot="only-icon" icon="navigate_back"></opac-icon>
    </opac-button>

    <h3>{{title() | translate}}</h3>

    <opac-button
      *ngIf="hasConsent()"
      (click)="closeDialog()"
      [ariaLabel]="'common.close' | translate"
      [opacTooltip]="'common.close' | translate">
      <opac-icon slot="only-icon" icon="close"></opac-icon>
    </opac-button>
  </div>

  <opac-cookies-overview *ngIf="step() === 'overview'"></opac-cookies-overview>
  <opac-cookies-settings *ngIf="step() === 'settings'"></opac-cookies-settings>

  <div class="actions" slot="actions">
    <opac-button type="text" (click)="changeStep('settings', $event)" *ngIf="step() === 'overview'">
      {{ 'cookies.configuration' | translate }}
    </opac-button>

    <div class="buttons-container">
      <opac-button type="secondary" (click)="rejectCookies()"> {{ 'cookies.reject' | translate }} </opac-button>
      <opac-button type="secondary" (click)="acceptAllCookies()"> {{ 'cookies.accept' | translate }} </opac-button>
      <opac-button type="secondary" (click)="confirmPreferences()" *ngIf="step() === 'settings'">
        {{ 'cookies.confirm.settings' | translate }}
      </opac-button>
    </div>
  </div>
</opac-dialog>
